<script setup lang="ts">
interface IProps {
  color?: string
  arrowColor?: string
  isGradient?: boolean
  size?: number
}

const props = withDefaults(
  defineProps<IProps>(),
  {
    color: '#FD93E7',
    size: 36,
    arrowColor: '#FFF',
  },
)

const iconSize = ref(props.size || (props.isGradient ? 12 : 36))
</script>

<template>
  <svg v-if="isGradient" :width="iconSize" :height="iconSize" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5086_60334)">
      <path d="M11.242 5.01813C10.5416 5.06566 9.9187 4.65541 9.66604 4.04503C9.52345 4.10006 9.37086 4.13758 9.21076 4.14759C8.38274 4.20513 7.66729 3.58224 7.60976 2.75922C7.59475 2.52408 7.63477 2.29643 7.71982 2.09131C7.09694 1.91119 6.62414 1.36335 6.57661 0.682925C6.5616 0.455283 6.59912 0.235145 6.67167 0.0350201C6.44903 0.0100045 6.22389 -0.00500488 5.99625 -0.00500488C2.68668 -1.75606e-06 0 2.68668 0 6.00125C0 9.31582 2.68668 12.0025 6.00125 12.0025C9.31582 12.0025 12.0025 9.31582 12.0025 6.00125C12.0025 5.601 11.9625 5.21075 11.8874 4.83302C11.6948 4.93808 11.4772 5.00313 11.2445 5.02064L11.242 5.01813Z" fill="url(#paint0_linear_5086_60334)" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.23413 6.02996L5.88751 2.6825L2.54089 6.02996L2.85913 6.34812L5.6625 3.54404V8.81472H6.1125V3.54402L8.91589 6.34812L9.23413 6.02996ZM5.94438 3.37585L5.88751 3.31897L5.83065 3.37585H5.94438Z" fill="white" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_5086_60334" x1="7.37409" y1="-8.86054" x2="-7.68478" y2="-3.76922" gradientUnits="userSpaceOnUse">
        <stop stop-color="#35DBFF" />
        <stop offset="0.427061" stop-color="#A993FF" />
        <stop offset="0.969543" stop-color="#FD93E7" />
      </linearGradient>
      <clipPath id="clip0_5086_60334">
        <rect :width="iconSize" :height="iconSize" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg v-else :width="size" :height="size" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M34.2173 10.7337C33.4668 11.4578 32.439 12.027 31.2668 11.7297C30.9469 11.6486 30.6642 11.5396 30.4153 11.4119C29.572 10.9794 27.2316 10.3644 26.3019 10.5484C25.351 10.7366 24.2584 10.6389 23.134 10.0137C22.2065 9.49792 21.6958 8.71664 21.4782 7.99276C21.2658 7.28593 20.6433 6.36434 19.9299 6.17507C18.8961 5.90078 17.7587 5.38086 17.2116 4.47614C16.4122 3.15427 16.7598 1.79196 17.0937 1.14567C17.1463 1.04381 17.2249 0.95884 17.3145 0.887289C17.33 0.874935 17.3453 0.862659 17.3606 0.850463C17.6021 0.657452 17.8184 0.484519 18.0423 0.336426C18.0317 0.336469 18.0212 0.33652 18.0107 0.336581L17.5597 0.339208C7.80525 0.396031 -0.0563705 8.34966 0.000304514 18.1041C0.0569795 27.8586 8.01048 35.7201 17.7649 35.6633L18.2159 35.6606C27.9704 35.6038 35.832 27.6502 35.7753 17.8957C35.7605 15.3427 35.2047 12.9193 34.2173 10.7337Z" :fill="color" />
    <path d="M25.9581 18.8512L25.4818 19.2704C25.3554 19.3817 25.1628 19.3754 25.044 19.256L18.893 13.0752C18.8664 13.0486 18.8205 13.067 18.8204 13.1044L18.7728 25.3025C18.7721 25.4756 18.63 25.6155 18.455 25.6155H17.5812C17.4061 25.6155 17.2641 25.4756 17.2634 25.3025L17.2158 13.1028C17.2156 13.0657 17.1702 13.0471 17.1435 13.0733L10.8444 19.2608C10.7253 19.3778 10.5346 19.383 10.4092 19.2726L9.93254 18.8532C9.79641 18.7333 9.78988 18.5251 9.91824 18.3972L17.7905 10.5524C17.9155 10.4277 18.1197 10.4286 18.2436 10.5544L25.9744 18.3972C26.1008 18.5255 26.0934 18.7321 25.9581 18.8512Z" :fill="arrowColor" />
  </svg>
</template>
